// Constants
import { mainThemeColours, secondaryLinear } from "Constants/ColourConstants";
import { BUTTON_BORDER_RADIUS } from "Constants/theme";

const getGradient = (isPrimary) => {
  const gradient = isPrimary
    ? {
        start: mainThemeColours.primary.dark,
        end: mainThemeColours.primary.light,
      }
    : {
        start: mainThemeColours.secondary.light,
        end: secondaryLinear,
      };

  return `linear-gradient(90deg, ${gradient.start} 0%, ${gradient.end} 100%)`;
};

export const styles = {
  chipBox: (isPrimary) => ({
    minWidth: "90px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    borderRadius: BUTTON_BORDER_RADIUS,
    backgroundImage: getGradient(isPrimary),
  }),
};
